import type { CSSProperties, FC, ReactNode } from 'react';

import { Theme } from '@highlight-cp/theme';
import { inter, lora, poppins } from '../../fonts';

interface ThemeShellProps {
  children?: ReactNode;
}

// Fonts and theme only, with no auth, store or project context, so error pages and the
// ErrorBoundary fallback can render core-ui even when the rest of the app can't. Theme is a
// static import so the fallback never waits on a chunk that may be what failed to load.
const ThemeShell: FC<ThemeShellProps> = ({ children }) => {
  const fontVariableStyle = {
    '--font-inter': inter.style.fontFamily,
    '--font-poppins': poppins.style.fontFamily,
    '--font-lora': lora.style.fontFamily,
  } as CSSProperties;

  return (
    <div className={inter.className} style={fontVariableStyle}>
      <Theme
        fontFamily={inter.style.fontFamily}
        fontFamilyHeadings={poppins.style.fontFamily}
        fontFamilyMonospace={inter.style.fontFamily}
      >
        {children}
      </Theme>
    </div>
  );
};

export default ThemeShell;
